// extracted by mini-css-extract-plugin
export default {"timerDivider":"Timer_timerDivider--Dss","timerTitle":"Timer_timerTitle--mrG","timerContainer":"Timer_timerContainer--NnM","bonuses":"Timer_bonuses--Q4F"};